import styled from 'styled-components'
import { get } from '../../utils/theme'

export const H3 = styled.h3`
  ${get('styles.h3')};
`
